<template>
  <el-dialog title="Create contest" :visible.sync="open" @closed="$emit('close')">
    <el-form>
      <div class="form-group">
        <label class="block">Choose an illustration image for the contest</label>
        <el-button @click="toggleLibraryManager">{{ $t('Choose from library...') }}</el-button>
        <img
          class="my-2"
          alt="illustration contest image"
          v-if="contest.mediacover"
          v-bind:src="contest.mediacover.url"
        />
        <library-manager
          v-show="isModalLibraryOpened"
          :open="isModalLibraryOpened"
          @close="closeLibrary"
          @selected="handleImageChange"
        ></library-manager>
      </div>
      <div class="form-group">
        <label>Title</label>
        <el-input type="title" v-model="contest.title[lang]" auto-complete="off" @change="checkTitle"></el-input>
      </div>
      <div class="form-group">
        <label>Description</label>
        <el-input
          type="description"
          v-model="contest.description[lang]"
          :autosize="{ minRows: 2, maxRows: 4 }"
          @change="checkDescription"
        ></el-input>
      </div>
      <div class="form-group">
        <label>Period</label><br />
        <el-date-picker
          v-model="period"
          type="daterange"
          :start-placeholder="$t('Start')"
          :end-placeholder="$t('End')"
          @change="onPeriodSelected"
        ></el-date-picker>
      </div> </el-form
    ><span class="dialog-footer" slot="footer">
      <el-button @click="$emit('close')">{{ $t('Cancel') }}</el-button>
      <el-button
        :disabled="!valid_contest"
        autofocus="autofocus"
        type="primary"
        native-type="submit"
        @click="saveContest"
        >{{ $t('Save') }}</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import LibraryManager from '../libraries/library-manager.vue'

export default {
  name: 'contest-form',
  components: { LibraryManager },

  props: {
    id: {
      type: String,
      required: false
    }
  },

  data() {
    return {
      open: true,
      contest: {},
      valid_contest: false,
      period_limited: false,
      period: null,
      isModalLibraryOpened: false,
      mediacover: null
    }
  },
  computed: {
    ...mapGetters('account', {
      site: 'currentSite',
      lang: 'defaultLang'
    }),

    ...mapGetters('contest', {
      getById: 'getById'
    })
  },
  watch: {
    site: {
      handler: 'init',
      immediate: true
    },
    contest: {
      handler: 'checkForm',
      deep: true
    }
  },
  methods: {
    ...mapActions('contest', ['addContest', 'updateContest']),

    init() {
      if (this.id) {
        let contest = this.getById(this.id)
        this.contest = this._.cloneDeep(contest, false)
        this.period = [new Date(this.contest.datestart), new Date(this.contest.dateend)]
      } else {
        this.contest = {
          title: {},
          description: {},
          datestart: null,
          dateend: null,
          mediacover: null
        }
      }

      this.checkForm()
    },

    checkTitle(content) {
      if (content.length === 0) {
        this.contest.title = {}
      }
    },

    checkDescription(content) {
      if (content.length === 0) {
        this.contest.description = {}
      }
    },

    onPeriodSelected(period) {
      if (period) {
        if (period[0]) {
          this.contest.datestart = period[0].toISOString()
          period[1].setDate(period[1].getDate() + 1)
          this.contest.dateend = period[1].toISOString()
        }
      } else {
        this.contest.startDate = null
        this.contest.endDate = null
      }
    },


    checkForm() {
      this.valid_contest =
      Object.keys(this.contest.title).length !== 0 > 0 &&
      Object.keys(this.contest.description).length > 0 &&
      this.contest.datestart != null &&
      this.contest.dateend != null

      console.log("checkForm", this.contest)
      return this.valid_contest
    },

    saveContest() {
      if (this.id) {
        this.updateContest({ contest: this.contest })
          .then(() => {
            this.$notify({ title: 'Success', message: this.$root.$t('notifications.contest.edited'), type: 'success' })
            this.$emit('close')
          })
          .catch(() => {
            this.$notify.error({ title: 'Success', message: this.$root.$t('notifications.unknown') })
          })
      } else {
        this.addContest({ contest: this.contest })
          .then(() => {
            this.$notify({ title: 'Success', message: this.$root.$t('notifications.contest.added'), type: 'success' })
            this.$emit('close')
          })
          .catch(() => {
            this.$notify.error({ title: 'Success', message: this.$root.$t('notifications.unknown') })
          })
      }
    },

    closeLibrary() {
      this.isModalLibraryOpened = false
    },

    toggleLibraryManager() {
      this.isModalLibraryOpened = !this.isModalLibraryOpened
    },

    handleImageChange(media) {
      this.contest.mediacover = {
        id: media.id,
        url: media.url
      }
      console.log(this.contest.mediacover)
      this.toggleLibraryManager()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/contests/contest-form.vue